import { TableCell, TableRow } from '@mui/material';
import { FC, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../../../components/shared/useUser';
import { TenantItem } from './TenantsTab';

type Props = {
  tenant: TenantItem;
};

const TenantItemRow: FC<Props> = ({ tenant }) => {
  const navigate = useNavigate();
  const { hasPermissionTo } = useContext(UserContext);

  const canEdit = hasPermissionTo(['TenantUpdate']);

  const handleRowClick = () => {
    if (!canEdit) return;
    navigate(`/admin/tenants/edit/${tenant.id}`);
  };

  return (
    <TableRow
      onClick={canEdit ? handleRowClick : undefined}
      sx={{
        cursor: canEdit ? 'pointer' : 'default',
        '&:hover': canEdit ? {
          backgroundColor: 'action.hover',
        } : undefined,
      }}
    >
      <TableCell>{tenant.id}</TableCell>
      <TableCell>{tenant.name}</TableCell>
    </TableRow>
  );
};

export default TenantItemRow;
